"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var translations = {
    account: {
        en: "Users",
        es: "Usuarios",
    },
    clients: {
        en: "Clients",
        es: "Clientes",
    },
    providers: {
        en: "Providers",
        es: "Proveedores",
    },
    sims: {
        en: "Sims",
        es: "Sims",
    },
    multiple: {
        en: "Multiple",
        es: "Multiple",
    },
    dashboard: {
        en: "Dashboard",
        es: "Dashboard",
    },
    reports: {
        en: "Reports",
        es: "Reportes",
    },
    groups: {
        en: "Groups",
        es: "Grupos",
    },
    models: {
        en: "Models",
        es: "Modelos",
    },
    events: {
        en: "Events",
        es: "Eventos",
    },
    alerts: {
        en: "Alerts",
        es: "Alertas",
    },
    services: {
        en: "Services",
        es: "Servicios",
    },
    positionEditor: {
        en: "Unit log",
        es: "Registro de unidades",
    },
    branding: {
        en: "Branding",
        es: "Marca",
    },
    config: {
        en: "Configuration",
        es: "Configuración",
    },
    generalConfig: {
        en: "General Configuration",
        es: "Configuración General",
    },
    profile: {
        en: "Profile",
        es: "Perfil",
    },
    weeklyRoute: {
        en: "Weekly Route",
        es: "Ruta Semanal",
    },
    weeklyMap: {
        en: "Weekly",
        es: "Semanal",
    },
    admin: {
        en: "Admin",
        es: "Administración",
    },
    syncRastreoOptimus: {
        en: "Rastreo Optimus Sync",
        es: "Sincronizar Rastreo Optimus",
    },
    fuelControl: {
        en: "Fuel Control",
        es: "Control de Combustible",
    },
    integrations: {
        en: "Integrations",
        es: "Integraciones",
    },
    driver: {
        en: "Drivers",
        es: "Conductores",
    },
    staff: {
        en: "Staff",
        es: "Personal",
    },
    simManager: {
        en: "Sims Manager",
        es: "Administrador de Sims",
    },
    cycleMonitoring: {
        en: "Cycle Monitoring",
        es: "Monitoreo de Ciclos",
    },
    deliveryCycle: {
        en: "Delivery Cycles",
        es: "Ciclos de Entrega",
    },
    deliveryMonitoring: {
        en: "Delivery Monitoring",
        es: "Monitoreo de Entregas",
    },
};
exports.default = translations;
